const YOUTUBE_EMBED_URL = process.env.NEXT_PUBLIC_YOUTUBE_EMBED_URL;

/**
 * Convert a YouTube watch / shortlink / embed URL into a player embed URL.
 * Recognised inputs:
 *   - https://www.youtube.com/watch?v=VIDEO_ID
 *   - https://www.youtube.com/watch?video=VIDEO_ID
 *   - https://www.youtube.com/embed/VIDEO_ID  (returned unchanged)
 *   - https://youtu.be/VIDEO_ID
 *
 * Returns an empty string for invalid or unsupported URLs so callers can
 * branch on falsiness without try/catch.
 */
export function convertToEmbedUrl(url: string): string {
  try {
    const urlObj = new URL(url);

    if (urlObj.hostname.includes("youtube.com")) {
      const videoId =
        urlObj.searchParams.get("v") ??
        urlObj.searchParams.get("video") ??
        (urlObj.pathname.startsWith("/embed/")
          ? urlObj.pathname.split("/embed/")[1]
          : null);

      if (videoId) return `${YOUTUBE_EMBED_URL}${videoId}`;
    }

    if (urlObj.hostname === "youtu.be") {
      const videoId = urlObj.pathname.slice(1);
      return `${YOUTUBE_EMBED_URL}${videoId}`;
    }

    if (urlObj.pathname.includes("/embed/")) {
      return url;
    }

    return "";
  } catch {
    return "";
  }
}
